import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(a, e) {
  return o(), l("svg", t, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8 4.837A2.837 2.837 0 0 1 10.837 2h2.326A2.837 2.837 0 0 1 16 4.837V6h3a1 1 0 1 1 0 2H5a1 1 0 0 1 0-2h3zm6 0V6h-4V4.837c0-.462.375-.837.837-.837h2.326c.462 0 .837.375.837.837m4.993 6.284a1 1 0 1 0-1.986-.242l-1.025 8.386a.84.84 0 0 1-.83.735H8.702a.837.837 0 0 1-.832-.75l-.876-8.354a1 1 0 1 0-1.99.208l.877 8.355A2.837 2.837 0 0 0 8.703 22h6.448a2.837 2.837 0 0 0 2.816-2.492zM11 11v6a1 1 0 1 0 2 0v-6a1 1 0 1 0-2 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: n };
export {
  d as default,
  n as render
};
//# sourceMappingURL=ic_trash-BbCvAhKD.js.map
